import { teachersConstants } from './constants';

const INITIAL_STATE = { 
    teacherCourses: [],
    courseSubject: {},
    courseStudents: [],
    courseEvals:{},
    courseStudentEvals: [],
    allEvals:[],

    notebookTools: [],
    notebookItems: []
 };


export function teachers(state = INITIAL_STATE, action) {
   switch (action.type) {
   

    
    case teachersConstants.ADD_COURSE_NOTEBOOK_ITEM:
        let notebookItemsNew = [...state.notebookItems].filter(f => ! ( f.course_subject_id === action.course_subject_id &&
          f.persona_id === action.persona_id && f.tool_id === action.tool_id )                              
          );
        let newItem = {
                        comments: action.comments,
                        course_subject_id: action.course_subject_id,
                        tool_id: action.tool_id,
                        persona_id: action.persona_id,
                        eval_type_opt_id: action.eval_type_opt_id,
                        eval_type_value: action.eval_type_value
                      }

        notebookItemsNew.push( newItem) ;
      
        return {
            ...state,
            notebookItems: notebookItemsNew
            };  

    case teachersConstants.SHOW_COURSE_NOTEBOOK_ITEMS:
      return {
          ...state,
          notebookItems: action.items
          };  

    case teachersConstants.SHOW_COURSE_NOTEBOOK_TOOLS:
      return {
          ...state,
          notebookTools: action.tools
          };  

    case teachersConstants.SHOW_COURSE_SUBJECT:
    return {
        ...state,
        courseSubject: action.courseSubject
        };  

    case teachersConstants.SHOW_COURSE_STUDENTS:
    return {
        ...state,
        courseStudents: action.courseStudents
        };  
      
    case teachersConstants.SHOW_COURSE_EVALS:
      return {
          ...state,
          courseEvals: action.courseEvals
          };  

    case teachersConstants.SHOW_ALL_EVALS:
      return {
          ...state,
          allEvals: action.allEvals
          };  
          

    case teachersConstants.SHOW_COURSE_STUDENT_EVALS:
      return {
          ...state,
          courseStudentEvals: action.courseStudentEvals
          };  

    case teachersConstants.ADD_COURSE_STUDENT_EVALS:
        let allEvalsNew = [...state.allEvals];

        let newCalif = {
                        comments: action.comments,
                        evaluation_id: action.evaluation_id,
                        persona_id: action.persona_id,
                        qualif_value_id: action.qualifValue.qualif_value_id,
                      }

            allEvalsNew.push( newCalif) ;
      
        return {
            ...state,
            allEvals: allEvalsNew
            };  
      
        
    case teachersConstants.UPD_COURSE_STUDENT_EVALS:
        let allEvalsNew2 = [];
        state.allEvals.map( orig => {
              if (orig.persona_id === action.persona_id && orig.evaluation_id === action.evaluation_id)  {

                if (action.data.qualif_value_id) orig.qualif_value_id = action.data.qualif_value_id;
                if (action.data.comments) orig.comments =  action.data.comments;
                  
              }
              allEvalsNew2.push( orig) ;
              return null;
          }
        );

      return {
          ...state,
          allEvals: allEvalsNew2
          };  


    case teachersConstants.DEL_COURSE_STUDENT_EVALS:

      let allEvalsNew3 = [];
      state.allEvals.map( orig => {
            if ( !(orig.persona_id === action.persona_id && orig.evaluation_id === action.evaluation_id))  {
              allEvalsNew3.push( orig) ;
            }
            return null;
        }
      );

    return {
        ...state,
        allEvals: allEvalsNew3
        };  
  

            
    case teachersConstants.SHOW_TEACHER_COURSES:
    return {
        ...state,
        teacherCourses: action.teacherCourses
        };  

    default:
      return state
  }
}

